// dependencies
import { List, Map } from "immutable";

const initialState = Map({
	possibleTimezones: List(),
	company: Map(),
	companyMfaEnabled: false,
	limits: Map(),
	asapAndDeferredNotifications: List(),
	deferredFrequencySettings: List(),
	asapAndDeferredEnabledState: null,
	digestDeliverySettings: Map(),
	digestEnabledState: null,
	digestNotifications: List(),
	adminDigestDeliverySettings: Map(),
	adminDigestEnabledState: null,
	adminDigestNotifications: List(),
	notificationsCompanyTemplates: Map(),
	betaFeatures: List(),
	customBilling: false,
	licenses: List(),
	decimalPlaces: 3,
});

export default function settings(state = initialState, action) {
	switch (action.type) {
		case "SETTINGS:GETTIMEZONES@SUCCESS": {
			return state.setIn(["possibleTimezones"], action.response.get("timezones", List()));
		}

		case "SETTINGS:GETCOMPANY@SUCCESS": {
			return state.withMutations((mutable) => {
				mutable.setIn(["limits"], action.response.get("limits"));
				mutable.setIn(["company"], action.response.get("functions"));
				mutable.setIn(["companyMfaEnabled"], action.response.getIn(["authentication", "mfaEnabled"], false));
				mutable.setIn(["betaFeatures"], action.response.get("betaFeatures"));
				mutable.setIn(["customBilling"], action.response.get("customBilling"));
				mutable.setIn(["licenses"], action.response.get("licenses"));
				mutable.setIn(["decimalPlaces"], action.response.get("decimal_places", 3));
			});
		}

		case "SETTINGS:GETASAPANDDEFERREDNOTIFICATIONS@SUCCESS": {
			return state.withMutations((mutable) => {
				mutable.setIn(["asapAndDeferredEnabledState"], action.response.get("enabledState"));
				mutable.setIn(["deferredFrequencySettings"], action.response.get("frequencySettings"));
				mutable.setIn(["asapAndDeferredNotifications"], action.response.get("notificationSettings", List()));
			});
		}

		case "SETTINGS:SETASAPANDDEFERREDNOTIFICATIONS@SUCCESS": {
			return state.withMutations((mutable) => {
				action.response.get("notificationSettings", List()).forEach((item) => {
					const id = item.get("name");
					const index = state
						.get("asapAndDeferredNotifications", List())
						.findIndex((notification) => notification.get("name") === id);

					mutable.setIn(["asapAndDeferredNotifications", index], item);
				});
			});
		}

		case "SETTINGS:GETWEEKLYDIGESTSETTINGS@SUCCESS": {
			return state.withMutations((mutable) => {
				mutable.setIn(["digestEnabledState"], action.response.get("enabledState"));
				mutable.setIn(["digestDeliverySettings"], action.response.get("deliverySettings"));
				mutable.setIn(["digestNotifications"], action.response.get("notificationSettings", List()));
			});
		}

		case "SETTINGS:SETWEEKLYDIGESTNOTIFICATIONS@SUCCESS": {
			return state.withMutations((mutable) => {
				action.response.get("notificationSettings", List()).forEach((item) => {
					const id = item.get("name");
					const index = state
						.get("digestNotifications", List())
						.findIndex((notification) => notification.get("name") === id);

					mutable.setIn(["digestNotifications", index], item);
				});
			});
		}

		case "SETTINGS:GETADMINWEEKLYDIGESTSETTINGS@SUCCESS": {
			return state.withMutations((mutable) => {
				mutable.setIn(["adminDigestEnabledState"], action.response.get("enabledState"));
				mutable.setIn(["adminDigestDeliverySettings"], action.response.get("deliverySettings"));
				mutable.setIn(["adminDigestNotifications"], action.response.get("notificationSettings", List()));
			});
		}

		case "SETTINGS:GETASAPANDDEFERREDNOTIFICATIONSTEMPLATE@SUCCESS": {
			return state.withMutations((mutable) => {
				mutable.setIn(
					["notificationsCompanyTemplates", "asapAndDeferredEnabledState"],
					action.response.get("enabledState")
				);
				mutable.setIn(
					["notificationsCompanyTemplates", "deferredFrequencySettings"],
					action.response.get("frequencySettings")
				);
				mutable.setIn(
					["notificationsCompanyTemplates", "asapAndDeferredNotifications"],
					action.response.get("notificationSettings", List())
				);
			});
		}

		case "SETTINGS:GETWEEKLYDIGESTSETTINGSTEMPLATE@SUCCESS": {
			return state.withMutations((mutable) => {
				mutable.setIn(
					["notificationsCompanyTemplates", "digestEnabledState"],
					action.response.get("enabledState")
				);
				mutable.setIn(
					["notificationsCompanyTemplates", "digestDeliverySettings"],
					action.response.get("deliverySettings")
				);
				mutable.setIn(
					["notificationsCompanyTemplates", "digestNotifications"],
					action.response.get("notificationSettings", List())
				);
			});
		}

		case "SETTINGS:GETADMINWEEKLYDIGESTSETTINGSTEMPLATE@SUCCESS": {
			return state.withMutations((mutable) => {
				mutable.setIn(
					["notificationsCompanyTemplates", "adminDigestEnabledState"],
					action.response.get("enabledState")
				);
				mutable.setIn(
					["notificationsCompanyTemplates", "adminDigestDeliverySettings"],
					action.response.get("deliverySettings")
				);
				mutable.setIn(
					["notificationsCompanyTemplates", "adminDigestNotifications"],
					action.response.get("notificationSettings", List())
				);
			});
		}

		case "SETTINGS:SETADMINWEEKLYDIGESTNOTIFICATIONS@SUCCESS": {
			return state.withMutations((mutable) => {
				action.response.get("notificationSettings", List()).forEach((item) => {
					const id = item.get("name");
					const index = state
						.get("adminDigestNotifications", List())
						.findIndex((notification) => notification.get("name") === id);

					mutable.setIn(["adminDigestNotifications", index], item);
				});
			});
		}

		case "SETTINGS:SETASAPANDDEFERREDNOTIFICATIONSTEMPLATE@SUCCESS": {
			return state.withMutations((mutable) => {
				action.response.get("notificationSettings", List()).forEach((item) => {
					const id = item.get("name");
					const index = state
						.getIn(["notificationsCompanyTemplates", "asapAndDeferredNotifications"], List())
						.findIndex((notification) => notification.get("name") === id);

					mutable.setIn(["notificationsCompanyTemplates", "asapAndDeferredNotifications", index], item);
				});
			});
		}

		case "SETTINGS:SETWEEKLYDIGESTSETTINGSTEMPLATE@SUCCESS": {
			return state.withMutations((mutable) => {
				action.response.get("notificationSettings", List()).forEach((item) => {
					const id = item.get("name");
					const index = state
						.getIn(["notificationsCompanyTemplates", "digestNotifications"], List())
						.findIndex((notification) => notification.get("name") === id);

					mutable.setIn(["notificationsCompanyTemplates", "digestNotifications", index], item);
				});
			});
		}

		case "SETTINGS:SETADMINWEEKLYDIGESTSETTINGSTEMPLATE@SUCCESS": {
			return state.withMutations((mutable) => {
				action.response.get("notificationSettings", List()).forEach((item) => {
					const id = item.get("name");
					const index = state
						.getIn(["notificationsCompanyTemplates", "adminDigestNotifications"], List())
						.findIndex((notification) => notification.get("name") === id);

					mutable.setIn(["notificationsCompanyTemplates", "adminDigestNotifications", index], item);
				});
			});
		}

		default:
			// never forget your default return state!
			return state;
	}
}
